/**
 * Ad-Reward State — client-side 24h "Premium unlock" granted after the
 * user finishes a rewarded ad. Stored in localStorage so it survives page
 * reloads and app restarts within the same device. Not synced across
 * devices (a rewarded unlock is intentionally short-lived and cheap).
 */
const KEY = 'matbakhi_rewarded_unlock_until';
const UNLOCK_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

export function hasRewardedUnlock() {
  const until = parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
  return until > Date.now();
}

export function grantRewardedUnlock() {
  const until = Date.now() + UNLOCK_DURATION_MS;
  localStorage.setItem(KEY, String(until));
  return until;
}

export function getUnlockRemainingMs() {
  const until = parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
  return Math.max(0, until - Date.now());
}

export function clearRewardedUnlock() {
  localStorage.removeItem(KEY);
}
